import XeroAdapter from './base';

export default class Connection extends XeroAdapter {
  modelNamePlural = 'connections';
}
